export const skillsData = [
    {
      label: "FRONT END",
      data: [
        {
          skillName: "REACT",
          percentage: "80",
        },
        {
          skillName: "HTML",
          percentage: "50",
        },
        {
          skillName: "CSS",
          percentage: "50",
        },
      ],
    },
    {
      label: "BACK END",
      data: [
        {
          skillName: "NODEJS",
          percentage: "70",
        },
        {
          skillName: "SQL",
          percentage: "65",
        },
        {
          skillName: "API",
          percentage: "80",
        },
        {
          skillName: ".NET",
          percentage: "40",
        },
      ],
    },
    {
      label: "LANGUAGES",
      data: [
        {
          skillName: "C++/C#",
          percentage: "90",
        },
        {
          skillName: "PYTHON",
          percentage: "80",
        },
        {
          skillName: "JAVASCRIPT",
          percentage: "70",
        },
        {
          skillName: "JAVA",
          percentage: "50",
        },
      ],
    },
  ];